<app-header></app-header>
<main class="pages">
    <!--PAGE Hero Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 alt="customer satisfaction survey" class="h1-title mt-3">Customer Experience </h1>
                    <h4 class="h2-title mt-lg-4 mt-2">
                        Collect relevant feedback from your customers and measure their satisfaction using CViewSurvey’s customer experience solution.

                    </h4>
                    <p class="sub-text mt-lg-3 text-justify"> These survey’s help you understand your customer and elevate their experience. Our surveys can help you create a customer centric culture and turn your customers into your brand ambassadors. The surveys offer solutions for Hospitals,
                        Educational Institutes,Chain Stores,IT & ITES etc.</p>

                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="Customer Experience" title="Customer Experience" src="assets/customer-experience.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="solutions py-lg-5">
        <div class="container pb-lg-5">
            <div class="col-md-12">
                <h4 class="section-title font-weight-bold text-center mb-4">Our surveys allow you to measure:</h4>
            </div>
            <div class="solution-points">

                <ul class="nav nav-tabs tab-titles">
                    <li class="tablinks active">
                        <a class="nav-link" data-id="#Cs">
                            <span class="sol-icon">
                        <img src="assets/target-audience.svg" alt="Target Audience">
                    </span>
                        </a>
                        <h6 class="sol-title  text-center">Customer Satisfaction Score (CSAT)</h6>
                    </li>
                    <li class="tablinks">
                        <a class="nav-link" data-id="#Ce">
                            <span class="sol-icon">
                        <img src="assets/brand-awareness.svg" alt="Brand Awareness">
                    </span>
                        </a>
                        <h6 class="sol-title  text-center">Customer Effort Score(CES)</h6>
                    </li>
                    <li class="tablinks">
                        <a class="nav-link" data-id="#Np">
                            <span class="sol-icon">
                        <img src="assets/product-feedback.svg" alt="Product Feedback">
                    </span>
                        </a>
                        <h6 class="sol-title  text-center">Net Promoter Score (NPS)</h6>
                    </li>
                </ul>

                <div class="pt-2 pb-3 pb-lg-0">
                    <div id="Cs" class="tab-content" style=display:block>
                        <div class="">
                            A customer satisfaction survey is a measure to know the level of satisfaction in customers regarding your product or service. These surveys identify happy customers who can later become brand advocates but they also identify customers who are likely to
                            spread negative reviews. They can be useful in recognising the loopholes if any in your product and offer an opportunity to improve.

                        </div>
                    </div>
                    <div id="Ce" class="tab-content">
                        <div>
                            This customer satisfaction survey is used to measure the ease of service and product experience for a company. It helps you test the effectiveness of your customer service and guide you to take appropriate decisions to take your business towards the growth
                            trajectory.
                        </div>
                    </div>
                    <div id="Np" class="tab-content">
                        <div>
                            This customer centric metric, is easy to understand and provides a clear picture of customer loyalty, on a scale of 0-10. It is considered one of an integral business KPI in many organisations as it helps track change over time.
                        </div>
                    </div>
                </div>
                <!-- <div class="alert alert-success blockquote mt-lg-5" role="alert">
                    Gather, analyze, and utilize the data on customer experience throughout your business and make further decisions accordingly. You can always gather valuable feedback from your customers and determine your priorities with the help of the CView Customer
                    Experience survey.
                </div> -->

            </div>
        </div>
    </section>

    <section class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>